import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import Header from './header';
import Nav from './nav';
import { FluxMapView } from '../../components/flux';

const HEADER_HEIGHT = 64;
const NAV_WIDTH = 280;
const NAV_COLLAPSE_WIDTH = 88;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: HEADER_HEIGHT + 24,
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('lg')]: {
    paddingTop: HEADER_HEIGHT + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const MapMain = styled('div')({
  flexGrow: 1,
  height: '100vh',
  paddingTop: HEADER_HEIGHT,
  overflow: 'hidden',
});

export default function MeasureLayout() {
  const [open, setOpen] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [visualMode, setVisualMode] = useState(false);
  const isDesktop = useResponsive('up', 'lg');
  const { pathname } = useLocation();

  const navWidth = isDesktop ? (isNavCollapsed ? NAV_COLLAPSE_WIDTH : NAV_WIDTH) : NAV_WIDTH;

  const getPageTitle = () => {
    if (visualMode) return 'Map View';
    if (pathname.includes('/measure/baseline')) return 'Baseline';
    if (pathname.includes('/measure/field-data') || pathname.includes('/measure/monitoring')) return 'Field Data';
    if (pathname.includes('/measure/spatial')) return 'Spatial Model';
    if (pathname.includes('/measure/calibrations')) return 'Calibrations';
    if (pathname.includes('/measure/reports')) return 'Reports';
    if (pathname.includes('/measure/settings')) return 'Settings';
    return 'Dashboard';
  };

  return (
    <StyledRoot>
      <Header
        onOpenNav={() => setOpen(true)}
        navWidth={visualMode ? 0 : navWidth}
        isNavCollapsed={isNavCollapsed}
        onToggleNavCollapse={() => setIsNavCollapsed((v) => !v)}
        pageTitle={getPageTitle()}
        visualMode={visualMode}
        onExitVisualMode={() => setVisualMode(false)}
      />

      {!visualMode && (
        <Nav
          openNav={open}
          onCloseNav={() => setOpen(false)}
          isNavCollapsed={isNavCollapsed}
          onLogoClick={() => setVisualMode(true)}
          visualMode={visualMode}
        />
      )}

      {visualMode ? (
        <MapMain>
          <FluxMapView />
        </MapMain>
      ) : (
        <Main>
          <Outlet />
        </Main>
      )}
    </StyledRoot>
  );
}
